import { FC } from 'react'

import styled from 'styled-components'

import { colors, device } from 'src/Helpers/constants.ts'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  gap: 10px;
  padding: 10px;
  width: 100%;

  @media ${device.tabletMax} {
    display: none;
  }
`

const ParametersContainer = styled.div`
  display: grid;
  grid-column-gap: 16px;
  grid-template-columns: 1.5fr 1fr 0.7fr 0.7fr 0.6fr;
  width: calc(100% - 10px);
`

const Parameter = styled.div`
  font-size: 12px;
  display: flex;
  align-items: center;
  color: ${colors.thirdGray};
  font-weight: 600;
`

export const TableHeader: FC = () => {
  return (
    <Container>
      <ParametersContainer>
        <Parameter>Имя</Parameter>
        <Parameter>Email</Parameter>
        <Parameter>Телефон</Parameter>
        <Parameter>Роль</Parameter>
        <Parameter />
      </ParametersContainer>
    </Container>
  )
}
